<template>
  <v-row
    justify="center"
    align="center"
    class="pt-4"
  >
    <v-progress-circular
      :size="70"
      color="#5c648b"
      indeterminate
    ></v-progress-circular>
  </v-row>
</template>

<script>
import Helper from "../../helper";
import authToken from "../../common/authToken";
import { ROUTER_URL, API_CLIENT_URL } from "../../constants/urls";
import Axios from "../../api/BaseAxios";
import Keys from "../../constants/keys";

export default {
  name: "ResourceInvitation",
  components: {},
  data () {
    return {
      token: null,
      resourceId: null,
      resourceTitle: null,
    };
  },
  created () {
    this.token = this.$route.params.token;
    this.decyptToken();
  },
  computed: {},
  watch: {},
  methods: {
    decyptToken () {
      let decryptedText = Helper.decryptData(this.token);
      console.log(decryptedText)
      this.resourceId = JSON.parse(JSON.parse(decryptedText)).id;
      this.resourceTitle = JSON.parse(JSON.parse(decryptedText)).title;
      this.gotoDetails();
    },
    gotoDetails () {
      if (authToken.isCorrectAccessToken()) {
        this.addResourceToInvitedResources();
        // this.$router.push({
        //   name: ROUTER_URL.publicResource.children.resourceDetails.name,
        //   params: {
        //     id: this.resourceId,
        //     title: this.resourceTitle,
        //   },
        // });
      } else {
        this.$router.push({
          name: ROUTER_URL.publicResource.children.resourceDetails.name,
          params: {
            id: this.resourceId,
            title: this.resourceTitle,
          },
        });
      }
    },
    addResourceToInvitedResources () {
      const successHandler = (res) => {
        console.log(res);

        if (authToken.is_eblity_admin()) {
          this.$router.push({
            name:
              ROUTER_URL.adminPanel.children.resources.children.resourceDetails
                .name,
            params: { id: this.resourceId },
          });
        } else {
          this.$router.push({
            name:
              ROUTER_URL.clientPanel.children.resources.children.resourceDetails
                .name,
            params: { id: this.resourceId },
          });
        }
      };

      const failureHandler = (res) => {
        console.log(res);
      };

      let requestParams = {};
      requestParams[Keys.RESOURCE_ID] = this.resourceId;

      Axios.request_POST(
        API_CLIENT_URL.clientAddResourceInvitation,
        requestParams,
        {},
        successHandler,
        failureHandler,
        false
      );
    },
  },
  mounted () { },
};
</script>

<style scoped></style>
z
